import styled from 'styled-components';
import "@fontsource/roboto-flex";
import { MediaQuery, Size } from '../../constant/breakpoint.ts';

export const Wrapper = styled('div')({
    backgroundColor:'#F1F1F1',
    width: "292px",
    height:"460px",
    textAlign: 'left',

    [MediaQuery[Size.XL]]: {
        width: "220px"
    },
    [MediaQuery[Size.MD]]: {
        width: "100%",
        height: "auto"
    },
})


export const Child = styled('div')({
    display: "flex",
    flex: "1 1 0",
    flexDirection: "column",    
})

export const CardBox = styled('div')({
    height: "auto",
    width: "auto",
    padding: "24px"
})

export const NewsTitle = styled('div')({
    fontFamily: 'Roboto Flex',
    fontSize: '30px',
    fontWeight: '400',
    [MediaQuery[Size.XL]]: {
        fontSize: "20px",
    },

    [MediaQuery[Size.MD]]: {
        fontSize: "30px",
    },
})

export const Newsmonth = styled('div')({
    fontFamily: 'Roboto Flex',
    fontSize: '12px',
    fontWeight: '700',
    color: '#CCA25E',
    marginTop: '2px',
    textDecoration: 'underline'
})

export const NewsDescription = styled('div')({
    fontFamily: 'Roboto Flex',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '16px',
    color: '#201F1F',
    marginTop: '16px'
})

export const ReadMoreButton = styled('div')({
    color: "#CCA25E",
    fontFamily: 'Roboto Flex',
    fontSize: '12px',
    fontWeight: '700',
    float: "right",
    marginTop: "0px",
    display: "flex",
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: "24px",
    cursor: "pointer"
})

export const Circle = styled('div')({
    height: "30px",
    width: "30px",
    backgroundColor: "#CCA25E",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "8px"
})

export const Arrow = styled('img')({
    width: "16px",
    height: "16px"
})

export const Description = styled('div')({
    fontFamily: 'Roboto Flex',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '18.75px',
    color: '#201F1F',
    marginTop: "16px",
    height: "120px",
    [MediaQuery[Size.XL]]: {
        height: "160px",
    },
    [MediaQuery[Size.SM]]: {
        height: "auto"
    },
})

export const Image = styled('img')({
    width: "100%",
    height: "168px",
    objectFit: "cover",

    [MediaQuery[Size.MD]]: {
        height: "auto",
        height: "240px",
    },
})